<template>
  <div class="search">
    <PageHeading title="Suche" />
    <div class="search__filter">
      <h3 class="search__filter-label">
        Bitte Suchbegriff eingeben:
      </h3>
      <input
        v-model="filter.search"
        type="search"
        placeholder="Suche"
        class="search__input"
        autofocus
        role="search"
      >
    </div>
    <PageContent>
      <section class="search__content">
        <ol v-if="items.length" class="search__list">
          <li v-for="result in items" :key="result.uuid" class="search__list-item">
            <SearchResult :result="result" />
          </li>
        </ol>
        <div v-if="searchEmpty" class="search__empty">
          <div class="search__empty-message">
            {{ appConfig.noResults }}
          </div>
        </div>
      </section>
    </PageContent>
    <div class="search__pager">
      <div class="search__pager-inner">
        <Pager
          v-if="items.length"
          :is-first-page
          :is-last-page
          :current-page
          :page-count
          @prev="prev"
          @next="next"
          @page-select="onPageSelect"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

const appConfig = useAppConfig()

const items = ref([])
const total = ref(0)
const pageSize = appConfig.defaultPageSize
const searchEmpty = ref(false)

const filter = ref({
  search: ''
})

const filterQuery = computed(() => {
  return {
    search: filter.value.search
  }
})

const { start, finish } = useLoadingIndicator()

const {
  currentPage,
  pageCount,
  isFirstPage,
  isLastPage,
  prev,
  next,
  offset,
  onPageSelect
} = await usePaginatedFilteredQuery(total, pageSize, fetchData, filterQuery)

async function fetchData (setData: Boolean = true) {
  if (filter.value.search.length < 2) {
    total.value = 0
    items.value = []
    return
  }
  start()
  return await useGraphqlQuery('search', {
    limit: pageSize,
    page: currentPage.value - 1,
    ...filterQuery.value
  }).then((v) => {
    if (setData) {
      // @todo: refactor this: move to usePaginatedFilteredQuery?
      total.value = v.data.search?.executable.execute.total_rows
      items.value = v.data.search?.executable.execute.rows
    }
    finish()
    total.value ? searchEmpty.value = false : searchEmpty.value = true
    return v.data
  })
}

useSeoMeta({
  title: 'Search'
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.search {
  &__filter {
    @include tools.grid;

    input[type='search'] {
      @include tools.form-field-search;

      &::placeholder {
        color: var(--color-text--highlight);
      }
    }
  }

  &__filter-label {
    @include tools.page-grid-columns;
    margin: 0;
  }

  &__input {
    @include tools.page-grid-columns;
    grid-row: 2;

  }

  &__content {
    @include tools.grid;
  }

  &__list {
    @include tools.page-grid-columns;
    display: flex;
    flex-direction: column;
    gap: var(--grid-gutter);
    margin: var(--space--l) 0;
    padding-left: 0;
  }

  &__list-item {
    margin-top: 0;
    padding-bottom: var(--grid-gutter);
    padding-left: 0;
    border-bottom: var(--border);
    list-style: none;
  }

  &__empty {
    @include tools.page-grid-columns;
    margin-top: var(--grid-gutter)
  }

  &__pager {
    @include tools.grid;
  }

  &__pager-inner {
    @include tools.page-grid-columns;
  }
}
</style>
